import { SceneTransform } from 'redux/mode/reducers';
import styled from 'styled-components';

interface SceneProps {
	transform: SceneTransform;
}
export const Scene = styled.div<SceneProps>`
	height: 100%;
	width: 100%;
	position: absolute;
	overflow: visible;

	transform: scale(${(p) => p.transform.scale})
		translate(
			${(p) => p.transform.offset.x / p.transform.scale}px,
			${(p) => p.transform.offset.y / p.transform.scale}px
		);
	transform-origin: top left;
`;

// Shares the canvas transform with S.Scene so comment markers benefit from the
// same single-transform optimization as frames. Rendered as a sibling *after*
// S.Scene so it paints on top. z-index:1 is needed because S.UI (the selection/
// hover overlay in Workspace) sits between S.Scene and this layer at z-index:0.
// This is a known cross-component z-index coupling -- if the stacking order in
// Workspace changes, this value may need updating.
export const CommentLayer = styled.div<SceneProps>`
	height: 100%;
	width: 100%;
	position: absolute;
	overflow: visible;
	pointer-events: none;
	z-index: 1;

	transform: scale(${(p) => p.transform.scale})
		translate(
			${(p) => p.transform.offset.x / p.transform.scale}px,
			${(p) => p.transform.offset.y / p.transform.scale}px
		);
	transform-origin: top left;
`;

interface BaseProps {
	color: string;
}
export const Base = styled.div<BaseProps>`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: ${(p) => p.color};
`;
